export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/audience.27145ac6.svg","height":64,"width":64};